/* unplugin-vue-components disabled */import script from "./UserInfo.vue?vue&type=script&setup=true&name=UserInfo&lang=js"
export * from "./UserInfo.vue?vue&type=script&setup=true&name=UserInfo&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=4e905945&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e905945"]])

export default __exports__